import * as React from 'react';
import useFetchWebinarData from "../Hooks/useFetchWebinarData";
export const WebDate = ({ id, dateText }) => {
  const data = useFetchWebinarData(id);
  const options = {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  const serveDate = (data && data.next_date) && new Date(data.next_date);
  const mskDate = serveDate && new Date(serveDate.setHours(serveDate.getHours() + 3));
  const eventDate = serveDate ? mskDate.toLocaleDateString('ru-RU', options) : 'Дата и время уточняются';
  return (
    <>{eventDate}{data && data.next_date ? dateText : null}</>
  );
};
